import { Directive, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appNgTemplate]',
})
export class TypedTemplateDirective<TypeToken> {
  // how you tell the directive what the type should be
  @Input() typeToken?: TypeToken;

  // this magic is how we tell Angular the context type for this directive, which then propagates down to the type of the template
  static ngTemplateContextGuard<TypeToken>(_: TypedTemplateDirective<TypeToken>, _ctx: unknown): _ctx is TypeToken {
    return true;
  }
}
